var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},_vm._l((_vm.services),function(item,index){return (_vm.can(item.gate, 'show') || _vm.can(item.gate, 'active'))?_c('v-col',{directives:[{name:"is-show",rawName:"v-is-show",value:(item.gate),expression:"item.gate"}],key:index,staticClass:"py-5 px-4 py-sm-6 py-md-8 zoom",class:_vm.$i18n.locale !== 'fa' && !_vm.activeNonPersianServices.includes(item.gate)
        ? 'opacity-60'
        : '',attrs:{"cols":"12","lg":"3","md":"4","sm":"6"}},[_c('v-card',{staticClass:"transparent d-flex",attrs:{"href":_vm.redirectTo(item.name, item.gate),"flat":"","height":"100%","width":"100%"}},[_c('div',{staticClass:"main-img-wrapper"},[_c('v-badge',{attrs:{"color":item.badge
              ? 'orange'
              : item.isFree
              ? _vm.preRegister.includes(item.name)
                ? 'orange'
                : 'bg-success'
              : item.comingSoon
              ? 'third'
              : item.isTest
              ? 'bg-warning'
              : '',"content":item.badge
              ? item.badge
              : item.isFree
              ? _vm.preRegister.includes(item.name)
                ? _vm.$t('badges.preRegister')
                : _vm.$t('badges.free')
              : item.comingSoon
              ? _vm.$t('badges.comingSoon')
              : item.isTest
              ? _vm.$t('badges.testVersion')
              : '',"value":item.isFree || item.comingSoon || item.isTest || item.badge,"bottom":"","left":"","offset-y":"10"}},[_c('img',{attrs:{"src":item.icon,"alt":"","height":"58","width":"58"}})])],1),_c('div',{staticClass:"bottom-sec",class:_vm.checkOverflow(index)},[_c('div',{staticClass:"bottom-text",domProps:{"textContent":_vm._s(item.description)}})]),_c('div',{staticClass:"main-sec",attrs:{"id":`main.text.${index}`}},[_c('div',{staticClass:"main-text-wrapper",attrs:{"id":`text.wrapper.${index}`},domProps:{"textContent":_vm._s(item.title)}})])])],1):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }